export const testimonials = [
  {
    id: 1,
    name: 'Aisha Mahmood',
    location: 'Islamabad',
    rating: 5,
    tag: 'Diabetes Management',
    review: 'I have been using Pearl Foods\' coconut flour and black seed oil for three months now. My blood sugar levels have stabilised and I feel so much more energetic. The purity of these products is unmatched – you can taste and feel the difference from the very first use.',
  },
  {
    id: 2,
    name: 'Tariq Hussain',
    location: 'Rawalpindi',
    rating: 5,
    tag: 'Digestive Wellness',
    review: 'After struggling with digestive issues for years, a friend recommended Pearl Foods\' hand ground masala and seed mix. Within weeks my digestion improved dramatically. These are not just food products – they are remedies. Completely natural, completely trustworthy.',
  },
  {
    id: 3,
    name: 'Sana Bibi',
    location: 'Islamabad',
    rating: 5,
    tag: 'General Wellness',
    review: 'The quality is absolutely exceptional. You can tell every product is made with genuine care and zero shortcuts. The sesame oil, the spices – everything has that authentic homemade taste I grew up with. Pearl Foods has become a permanent part of our household.',
  },
  {
    id: 4,
    name: 'Dr. Khalid Rehman',
    location: 'Rawalpindi',
    rating: 5,
    tag: 'Piles Relief',
    review: 'As a health professional I am very selective about natural product recommendations. Pearl Foods meets my standards. The seed mix and oils are genuinely chemical-free and the health benefits my patients report are real and consistent. Highly recommended.',
  },
];
